/*
==================================================
AUREALM CHAKRA GUIDE V2
Motion + Sticky Navigation — Fixed
==================================================
*/

(function () {
  'use strict';

  const guide = document.querySelector('[data-au-chakra-guide]');
  const pageHasChakra = document.querySelector('.au-chakra-overview');

  if (!guide && !pageHasChakra) return;

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const navLinks = document.querySelectorAll('.au-chakra-nav a');

  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');

      if (!targetId || targetId === '#') return;

      const target = document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  const sections = [
    ...document.querySelectorAll('.au-chakra-card, .au-chakra-detail')
  ];

  if ('IntersectionObserver' in window) {
    const navObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const id = entry.target.getAttribute('id');

        navLinks.forEach((link) => {
          link.classList.remove('is-active');

          if (link.getAttribute('href') === '#detail-' + id) {
            link.classList.add('is-active');
          }
        });
      });
    }, {
      rootMargin: '-40% 0px -50% 0px',
      threshold: 0
    });

    sections.forEach((section) => {
      navObserver.observe(section);
    });
  }

  if (
    !prefersReducedMotion &&
    'IntersectionObserver' in window
  ) {
    const revealItems = [
      ...document.querySelectorAll(
        '.au-chakra-card, .au-chakra-detail, .au-state-card, .au-ritual-card, .au-chakra-cross__inner, .au-chakra-close__inner'
      )
    ];

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');

        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px'
    });

    revealItems.forEach((item, index) => {
      item.style.transitionDelay = Math.min(index * 55, 330) + 'ms';
      revealObserver.observe(item);
    });
  } else {
    document
      .querySelectorAll(
        '.au-chakra-card, .au-chakra-detail, .au-state-card, .au-ritual-card, .au-chakra-cross__inner, .au-chakra-close__inner'
      )
      .forEach((item) => item.classList.add('is-visible'));
  }
})();